import { useState, useCallback } from 'react';

// Asset types and states
const ASSET_TYPES = {
    MODEL: 'model',
    IMAGE: 'image',
    VIDEO: 'video'
};

const ASSET_STATES = {
    LOADING: 'loading',
    READY: 'ready',
    ERROR: 'error'
};

export const useAssetManager = () => {
    // Core state
    const [assets, setAssets] = useState({});
    const [loadingStates, setLoadingStates] = useState({});
    const [selectedAsset, setSelectedAsset] = useState(null);

    // Asset loading
    const loadAsset = useCallback(async (id, url, type) => {
        setLoadingStates(prev => ({ ...prev, [id]: ASSET_STATES.LOADING }));

        try {
            // Create new asset entry with all original properties
            const newAsset = {
                id,
                url,
                type,
                position: [0, 0, 0],
                rotation: [0, 0, 0],
                scale: 1,
                autoRotate: true,
                hidePodium: false,
                // Add any other properties your assets need
                ...assets[id]  // Preserve any existing properties
            };

            setAssets(prev => ({
                ...prev,
                [id]: newAsset
            }));

            setLoadingStates(prev => ({ ...prev, [id]: ASSET_STATES.READY }));
        } catch (error) {
            console.error('Failed to load asset:', error);
            setLoadingStates(prev => ({ ...prev, [id]: ASSET_STATES.ERROR }));
        }
    }, []);

    // Update asset properties
    const updateAsset = useCallback((id, changes) => {
        setAssets(prev => ({
            ...prev,
            [id]: {
                ...prev[id],
                ...changes
            }
        }));
    }, []);

    // Remove asset
    const removeAsset = useCallback((id) => {
        setAssets(prev => {
            const newAssets = { ...prev };
            delete newAssets[id];
            return newAssets;
        });
        setLoadingStates(prev => {
            const newStates = { ...prev };
            delete newStates[id];
            return newStates;
        });
    }, []);

    // Select asset for editing
    const selectAsset = useCallback((id) => {
        setSelectedAsset(id);
    }, []);

    return {
        assets,
        loadingStates,
        selectedAsset,
        loadAsset,
        updateAsset,
        removeAsset,
        selectAsset,
        ASSET_TYPES,
        ASSET_STATES
    };
}; 